import React from 'react';
import { styled } from 'styled-components';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { Download } from '../../../components/ClickableComponents/Download';
import { colorSets } from '../../../components/ClickableComponents/styles';
import { WatchLaterCheckbox } from '../../../components/ClickableComponents/WatchLaterCheckbox';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VideoActions = ({
  videoDetail
}) => /*#__PURE__*/_jsxs(StyledVideoAction, {
  children: [/*#__PURE__*/_jsx(StyledDownload, {
    colorSet: colorSets.secondary,
    downloads: videoDetail
  }), /*#__PURE__*/_jsx(StyledWatchLaterCheckbox, {
    videoUrn: videoDetail.urn
  })]
});
const StyledVideoAction = styled.div.withConfig({
  displayName: "VideoActions__StyledVideoAction",
  componentId: "sc-15bq162-0"
})(["display:flex;flex-wrap:wrap;gap:8px;"]);
const StyledWatchLaterCheckbox = styled(WatchLaterCheckbox).withConfig({
  displayName: "VideoActions__StyledWatchLaterCheckbox",
  componentId: "sc-15bq162-1"
})(["", "{width:100%;}"], Viewports.for('small'));
const StyledDownload = styled(Download).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "VideoActions__StyledDownload",
  componentId: "sc-15bq162-2"
})(["", "{width:100%;}"], Viewports.for('small'));